import React from "react";
import { Route, Routes } from "react-router-dom";
import GroupTable from "./Group/GroupTable";
import LedgerTable from "./Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import { useClient } from "../../Context/ClientContext";
import { useUser } from "../../../Context/UserContext";
import ResourceNotFound from "../../Common/ResourceNotFound";
import Departments from "../Organisations/Departments";

const MasterNestedRoute = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();
  return (
    <Routes>
      <Route
        path="/group"
        element={
          findUserOnlyOnePremission(
            "Master.Group.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <GroupTable
              searchLedgerByGroupsTypes={SearchLedgerByGroupsTypes.All}
              showName="Group"
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/ledger"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              showName={"Ledger"}
              ledgerByGroupsType={SearchLedgerByGroupsTypes.All}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* <Route path="/items" element={<Items itemPage={ItemType.All} />} />
      <Route path="/itemgroups" element={<ItemGroups />} />
      <Route path="/itemCategory" element={<ItemCategory />} />
      <Route path="/itemlocations" element={<ItemLocations />} />
      <Route path="/units" element={<UnitsItems />} />
       */}
    </Routes>
  );
};

export default MasterNestedRoute;
